import React, { Component } from 'react';
import { Footer, NavBar, Session } from "../../components";
import { config, DISPATCH_ID, SERVICE_API, VIEW_NAME, ROLES, SERVICE_RESPONSE, licence } from "../../libs/utils/Const";
import { connect } from "react-redux";
import { PayPalButton } from "react-paypal-button";
import { ApiClient } from "../../libs/apiClient/ApiClient";
import CurrencyFormat from 'react-currency-format';
import CommentsModal from '../../components/CommentsModal';
import { CSVLink, CSVDownload } from "react-csv";
import $ from 'jquery';
import packageJson from '../../../package.json';
import moment from 'moment';
import ExportReportPDFOrder from '../../components/ExportReportPDFOrder';
global.appVersion = packageJson.version;

const apiClient = ApiClient.getInstance();
// Definicion de un arreglo para el producto Flete
let responseFlete = { ItemCode: '', ItemName: '', Price: '0', PriceList: '0', PurchaseLimit: '' };

let paypalOptions = {
    clientId: config.paymentMethod.paypal.clienId,
    intent: 'capture',
    commit: true
};

const buttonStyles = {
    layout: 'vertical',
    shape: 'pill',
    color: 'silver'
};

class ValidateOrderView extends Component {
    state = {
        address: {},
        bill: {},
        paymentMethod: '',
        totalOrder: 0,
        seller: JSON.parse(localStorage.getItem(config.general.localStorageNamed + 'PartnerUser')),
        csvData: [],
        fechaActual: '',
        DocDueDate: '',
        userFields: []
    };

    async componentDidMount() {
        const { history, sessionReducer: { role } } = this.props;
        //Mandar traer el flete
        let responseApi = await this.getRegisterPack();

        let item_code = responseApi.data[0].ItemCode;
        let item_name = responseApi.data[0].ItemName;
        let price = responseApi.data[0].Price;
        let price_list = responseApi.data[0].PriceList;
        let purchase_limit = responseApi.data[0].PurchaseLimit;
        //Asigancion de los valores al arreglo del front
        responseFlete.ItemCode = item_code;
        responseFlete.ItemName = item_name;
        responseFlete.Price = price;
        responseFlete.PriceList = price_list;
        responseFlete.PurchaseLimit = purchase_limit;
        //console.log("Hola",responseFlete);
        let data = sessionStorage.getItem('validateOrder');
        data = JSON.parse(data || '{}');
        const { date, paymentMethod, address, bill } = data;
        //Obtener del local el arreglo de regalos
        //let itemsGift =  JSON.parse(localStorage.getItem(config.general.localStorageNamed + 'Gift'));

        let newDate = new Date();
        let diferent = newDate.getTime() - (date ? new Date(date).getTime() : 0);
        if (diferent > 30000) {
            history.push('/shoppingCart');
        }
        let newAddress = {};
        let newBill = {};
        if (role === ROLES.PUBLIC) {
            newAddress.name = address.name || '';
            newAddress.email = address.email || '';
            newAddress.phone = address.phone || '';
            newAddress.street = address.street || '';
            newAddress.block = address.suburb || '';
            newAddress.city = address.city || '';
            newAddress.cp = address.cp || '';
            newAddress.state = address.stateName || '';
            newAddress.country = address.countryName || '';
            newAddress.U_SYP_RICO_CREGION = address.U_SYP_RICO_CREGION;
            newAddress.U_SYP_RICO_NREGION = address.U_SYP_RICO_NREGION;
        }

        if (role === ROLES.CLIENT) {
            newAddress.address = address.Address || '';
            newAddress.street = address.Street || '';
            newAddress.block = address.Block || '';
            newAddress.city = address.City || '';
            newAddress.cp = address.ZipCode || '';
            newAddress.state = address.StateName || '';
            newAddress.country = address.CountryName || '';
            newAddress.U_SYP_RICO_CREGION = address.U_SYP_RICO_CREGION;
            newAddress.U_SYP_RICO_NREGION = address.U_SYP_RICO_NREGION;
        }
        if (role === ROLES.CLIENT) {
            newBill.address = bill.Address || '';
            newBill.street = bill.Street || '';
            newBill.block = bill.Block || '';
            newBill.city = bill.City || '';
            newBill.cp = bill.ZipCode || '';
            newBill.state = bill.StateName || '';
            newBill.country = bill.CountryName || '';
            newBill.county = bill.County || '';
        }
        const f = new Date;
        let nedate = f.setDate(f.getDate() + 1)

        this.setState({
            address: newAddress,
            bill: newBill,
            paymentMethod: paymentMethod || '',
            fechaActual: moment(new Date()).format('YYYY-MM-DD'),
            DocDueDate: moment(nedate).format('YYYY-MM-DD'),
        })
    }

    getRegisterPack = async () => {
        //this.state(await apiClient.getFlete());
        return await apiClient.getFlete();
    }

    getRegisterPack = async () => {
        //this.state(await apiClient.getFlete());
        return await apiClient.getFlete();
    }

    renderItem = (item, index) => {
        // console.log('con<',item.ItemCode, item.priceTax);
        return <div key={index} className='row' style={{ padding: 10, textAlign: 'center' }}>
            {!(!!item.OnHand) && <div className='col-12' style={{
                marginBottom: 5,
                padding: 5,
                backgroundColor: config.navBar.backgroundColor, color: config.navBar.textColor
            }}>
                Agotado
            </div>}
            <div className='col-sm-3' style={{ margin: 0 }}>
                <img
                    className="img-fluid "
                    style={{
                        backgroundColor: 'white',
                        maxHeight: 130
                    }}
                    src={item.PicturName ? (config.BASE_URL + SERVICE_API.getImage + '/' + item.PicturName) : require('../../images/noImage.png')}
                    alt=""
                />
            </div>


            <div className='col-sm-9'>
                <div className="container p-0">
                    <div className="row">
                        <div className="col-12" style={{ borderBottom: '1px solid rgb(124, 124, 125)' }}>
                            <div className='text-left'>
                                {item.ItemName}
                            </div>
                        </div>
                    </div>
                    <div className="row font-weight-bold">
                        <div className="col-md-12 table-responsive">
                            <table class="table">
                                <thead>
                                    <tr >
                                        <th scope="col">Código</th>
                                        <th scope="col">Cantidad</th>
                                        <th scope="col">Precio unitario</th>
                                        <th scope="col">Descuento</th>
                                        <th scope="col">Precio total</th>
                                        <th scope="col">Peso neto</th>
                                        <th scope="col">Peso bruto</th>
                                        <th scope="col"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <td>
                                        {item.ItemCode}
                                    </td>
                                    <td>
                                        <input
                                            //disabled={!(!!item.OnHand)}
                                            disabled={true}
                                            id={'input-quantity-' + item.ItemCode + index}
                                            type="number"
                                            min="1"
                                            value={item.quantity ? Number(item.quantity) : ''}
                                            className="form-control"
                                            name={'quantity' + item.ItemCode}
                                            placeholder="Cantidad"
                                            style={{ textAlign: 'center' }}
                                            onChange={(event) => {
                                                this.changeQuantity(index, item, event)
                                            }}
                                            onBlur={(e) => this.validateQuantity(index, item, e)} />
                                    </td>

                                    <td>
                                        <CurrencyFormat
                                            // value={item.Price}
                                            value={item.priceTax}
                                            displayType={'text'}
                                            thousandSeparator={true}
                                            fixedDecimalScale={true}
                                            decimalScale={2}
                                            prefix={config.general.currency}>
                                        </CurrencyFormat>
                                    </td>

                                    <td>
                                        {item.Discount === null ? '0 %' : parseFloat(item.Discount).toFixed(2) + ' %'}
                                    </td>

                                    <td>
                                        <CurrencyFormat
                                            // value={item.Price * item.quantity - (item.Price * item.quantity * (item.Discount / 100))}
                                            value={item.priceTax * item.quantity}
                                            displayType={'text'}
                                            thousandSeparator={true}
                                            fixedDecimalScale={true}
                                            decimalScale={2}
                                            prefix={config.general.currency}>
                                        </CurrencyFormat>
                                    </td>

                                    <td>
                                        {parseFloat(item.quantity * item.weight).toFixed(2) + ' KG'}
                                    </td>

                                    <td>
                                        {parseFloat(item.quantity * item.weight1).toFixed(2) + ' KG'}
                                    </td>


                                    <td></td>
                                </tbody>

                            </table>

                        </div>
                    </div>

                </div>
                {!(!!item.OnHand) &&
                    <div className='row text-center' style={{ margin: 0, padding: 0 }}>
                        <div className='col-2' style={{
                            color: item.OnHand ? 'rgb(13, 98, 168)' : 'rgb(124, 124, 125)',
                            fontSize: 30,
                            padding: 0
                        }}>
                        </div>
                    </div>}

            </div>

        </div>
    };

    renderItemPromo = element => {
        let item = element.bonificacion;

        //    return  element.map((item,index) => {
        return (
            <div key={1} className='row' style={{ padding: 10, textAlign: 'center' }}>
                {/* {!(!!item.OnHand) && <div className='col-12' style={{
                    marginBottom: 5,
                    padding: 5,
                    backgroundColor: config.navBar.backgroundColor, color: config.navBar.textColor
                }}>
                    Agotado
                </div>} */}
                <div className='col-sm-3' style={{ margin: 0 }}>
                    <img
                        className="img-fluid "
                        style={{
                            backgroundColor: 'white',
                            maxHeight: 130
                        }}
                        src={item.PicturName ? (config.BASE_URL + SERVICE_API.getImage + '/' + item.PicturName) : require('../../images/noImage.png')}
                        alt=""
                    />
                </div>


                <div className='col-sm-9'>
                    <div className="container p-0">
                        <div className="row">
                            <div className="col-12" style={{ borderBottom: '1px solid rgb(124, 124, 125)' }}>
                                <div className='text-left'>
                                    {item.ItemName}
                                </div>
                            </div>
                        </div>
                        <div className="row font-weight-bold">
                            <div className="col-md-12 table-responsive">
                                <table class="table">
                                    <thead>
                                        <tr >
                                            <th scope="col">Código</th>
                                            <th scope="col">Cantidad</th>
                                            {/* <th scope="col">Precio unitario</th>
                                            <th scope="col">Descuento</th>
                                            <th scope="col">Precio total</th>
                                            <th scope="col">Peso neto</th>
                                            <th scope="col">Peso bruto</th> */}
                                            <th scope="col"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <td>
                                            <i className="fa fa-gift" data-toggle="tooltip" title={'Artículo de regalo'} style={{ cursor: 'pointer', paddingRight: "5px", color: '#005DA8' }} />
                                            {item.idProducto}
                                        </td>
                                        <td>
                                            <input
                                                //disabled={!(!!item.OnHand)}
                                                disabled={true}
                                                id={'input-quantity-' + item.idProducto + 1}
                                                type="number"
                                                min="1"
                                                value={item.cantidad ? Number(item.cantidad) : ''}
                                                className="form-control"
                                                name={'quantity' + item.idProducto}
                                                placeholder="Cantidad"
                                                style={{ textAlign: 'center' }} />
                                        </td>

                                        {/* <td>
                                            <CurrencyFormat
                                                value={item.Price || 0}
                                                displayType={'text'}
                                                thousandSeparator={true}
                                                fixedDecimalScale={true}
                                                decimalScale={2}
                                                prefix={config.general.currency}>
                                            </CurrencyFormat>
                                        </td> */}

                                        {/* <td>
                                            {item.Discount === null ? '0 %' : 0 + ' %'}
                                        </td>
    
                                        <td>
                                            <CurrencyFormat
                                                value={0 * item.cantidad - (0 * item.cantidad * (0 / 100))}
                                                displayType={'text'}
                                                thousandSeparator={true}
                                                fixedDecimalScale={true}
                                                decimalScale={2}
                                                prefix={config.general.currency}>
                                            </CurrencyFormat>
                                        </td>
    
                                        <td>
                                            {parseFloat(item.cantidad * 0).toFixed(2) + ' KG'}
                                        </td>
    
                                        <td>
                                            {parseFloat(item.cantidad * 0).toFixed(2) + ' KG'}
                                        </td> */}


                                        <td></td>
                                    </tbody>

                                </table>

                            </div>
                        </div>

                    </div>
                    {!(!!item.OnHand) &&
                        <div className='row text-center' style={{ margin: 0, padding: 0 }}>
                            <div className='col-2' style={{
                                color: item.OnHand ? 'rgb(13, 98, 168)' : 'rgb(124, 124, 125)',
                                fontSize: 30,
                                padding: 0
                            }}>
                            </div>
                        </div>}

                </div>

            </div>
        )





    };

    renderAddress = () => {
        const { address } = this.state;

        let addressComplete = (address.street || '') + ' ' + (address.block || '') + ' ' + (address.city || '') + ' C.P. ' + (address.cp || '') + ', ' + (address.state || '') + ', ' + (address.country || '') + '.';
        let name = address.name;
        let email = address.email;
        let phone = address.phone;

        return <div>
            {name && <div className='col-12'>Nombre de comprador: {name}</div>}
            {email && <div className='col-12'>Email de comprador: {email}</div>}
            {phone && <div className='col-12'>Teléfono de comprador: {phone}</div>}

            <div>
                {addressComplete}
                <br />
            </div>
        </div>
    };

    enviar = async () => {
        const { notificationReducer: { showAlert }, shoppingCartReducer: { itemsGift } } = this.props;
        const { seller, DocDueDate } = this.state;
        let today = new Date();

        if (today > licence) {
            showAlert({ type: 'info', message: 'LA LICENCIA DE ESTE PRODUCTO A EXPIRADO, FAVOR DE CONTACTAR AL ADMINISTRADOR.' });
            return;
        }

        if (!DocDueDate) {
            showAlert({ type: 'error', message: 'No puedes crear el documento sin fecha de entrega' });
            return;
        }

        if (seller.U_FMB_Handel_Perfil != '0') {
            for (let i = 0; i < itemsGift.length; i++) {
                const stock = itemsGift[i];
                if ((stock.bonificacion.cantidad > stock.bonificacion.Stock) && !!stock.bonificacion.Stock) {
                    showAlert({ type: 'error', message: "El artículo de bonificación: " + stock.bonificacion.idProducto + ' no tiene stock suficiente', timeOut: 5000 })
                }
            }
        }

        $('#commentsModal').modal('show');

        this.setState({
            comentario: 1
        })
    }

    sendOrder = async (response = null) => {
        const { enableSpinner, sessionReducer: { role, user }, notificationReducer: { showAlert }, shoppingCartReducer: { items, itemsGift }, itemsReducer: { deleteShoppingCart }, configReducer: { history } } = this.props;
        const { address, bill, DocDueDate } = this.state;
        let shoppingCart = [];
        enableSpinner(true);

        if (role === ROLES.PUBLIC) {
            let localShoppingCart = localStorage.getItem(config.general.localStorageNamed + 'shoppingCart');

            localShoppingCart = JSON.parse(localShoppingCart);

            if (!localShoppingCart) {
                localStorage.setItem(config.general.localStorageNamed + 'shoppingCart', JSON.stringify([]));
            }
            //console.log(localShoppingCart)
            shoppingCart = localShoppingCart || []
        }
        //Creador del documento
        let creatorUser = JSON.parse(localStorage.getItem(config.general.localStorageNamed + 'PartnerUser'));
        let empID = JSON.parse(localStorage.getItem(config.general.localStorageNamed + 'Vendor'));
        let creator;
        if (Number(creatorUser.U_FMB_Handel_Perfil) === 1) {
            creator = "Telemarketing:" + (creatorUser.salesPrson || creatorUser.empID) + ", " + creatorUser.firstName + " " + creatorUser.lastName;
        } else if (Number(creatorUser.U_FMB_Handel_Perfil) === 2) {
            creator = "Vendedor:" + (creatorUser.salesPrson || creatorUser.empID) + ", " + creatorUser.firstName + " " + creatorUser.lastName;
        } else if (Number(creatorUser.U_FMB_Handel_Perfil) === 3) {
            creator = "Administrador:" + (creatorUser.salesPrson || creatorUser.empID) + ", " + creatorUser.firstName + " " + creatorUser.lastName;
        } else {
            creator = "B2B:" + user.CardName;
        }
        //Definicion del vendedor
        empID = empID.salesPerson;

        /////////////////////////////////////////////////////---------------Quitar Bonificacion sin Stock---------------/////////////////////////////////////////////////////

        // let deleteItems : any = [];
        // console.log("con<<<<<<<<<<<<<<<<<<<<<<<<<<<<<", items, itemsGift)

        for (let a = 0; a < items.length; a++) {
            const data = items[a];
            for (let i = 0; i < itemsGift.length; i++) {
                const stock = itemsGift[i];

                // console.log('con< itemsRegalos',data.ItemCode,data.quantity,data.OnHand, 'Bonificacion:', stock.bonificacion.idProducto, stock.bonificacion.Stock, stock.bonificacion.cantidad, parseInt(stock.bonificacion.Stock));
                let missing = parseInt(data.OnHand - (parseInt(data.quantity) + stock.bonificacion.cantidad));

                if (data.ItemCode == stock.bonificacion.idProducto && missing < 0) { //Cualquera menor de 0 falta entregar

                    if (data.OnHand - parseInt(data.quantity) === 0) { //Identifico cuanto falta entregar
                        stock.bonificacion.stockMissing = Math.abs(missing);
                        stock.bonificacion.comment = 'Has regalado ' + 0 + '/' + stock.bonificacion.cantidad;
                        stock.bonificacion.quantity = 0;
                    } else if (data.OnHand - parseInt(data.quantity) > 0) {
                        stock.bonificacion.stockMissing = Math.abs(missing);
                        stock.bonificacion.comment = 'Has regalado ' + (data.OnHand - parseInt(data.quantity)) + '/' + stock.bonificacion.cantidad;
                    }
                } else if (stock.bonificacion.cantidad > stock.bonificacion.Stock) {
                    if (stock.bonificacion.Stock <= 0) {
                        stock.bonificacion.stockMissing = stock.bonificacion.cantidad;
                        stock.bonificacion.comment = 'Has regalado ' + 0 + '/' + stock.bonificacion.cantidad;
                        // stock.bonificacion.comment = 'Has regalado ' + (stock.bonificacion.cantidad - stock.bonificacion.stockMissing) + '/' + stock.bonificacion.cantidad;
                        let inicio = stock.bonificacion.comment.indexOf('regalado ');
                        let final = stock.bonificacion.comment.indexOf('/');
                        let cantidadAntesDeOrden = stock.bonificacion.comment.slice(inicio, final);
                        // console.log('con<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<',cantidadAntesDeOrden);
                    } else {
                        let missing = stock.bonificacion.Stock - stock.bonificacion.cantidad;
                        stock.bonificacion.stockMissing = Math.abs(missing);
                        stock.bonificacion.comment = 'Has regalado ' + stock.bonificacion.Stock + '/' + stock.bonificacion.cantidad;
                    }

                }
            }
        }

        // console.log('con<<<<<',itemsGift);
        ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// 


        let data = {
            shoppingCart,
            address,
            bill,
            objType: '17',
            responseFlete,
            empID,
            creator,
            taxOnly: 0,
            venta: '01',
            comment: response,
            itemsGift,
            Version: 'VerF: ' + global.appVersion,
            DocDueDate,
            creatorUser,
        };

        let apiResponse = await apiClient.createDocument(data);

        if (apiResponse.status === SERVICE_RESPONSE.SUCCESS) {
            deleteShoppingCart({ item: {}, deleteAll: true });
            enableSpinner(false);
            localStorage.setItem(config.general.localStorageNamed + 'createOrder', apiResponse.data.docNum);
            history.goCreateOrder();
            return;
        }

        showAlert({ type: 'error', message: apiResponse.message });
        enableSpinner(false)

    };

    enviarVta = async () => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        const { DocDueDate, userFields } = this.state;
        let today = new Date();

        if (today > licence) {
            showAlert({ type: 'info', message: 'LA LICENCIA DE ESTE PRODUCTO A EXPIRADO, FAVOR DE CONTACTAR AL ADMINISTRADOR.' });
            return;
        }

        if (!DocDueDate) {
            showAlert({ type: 'error', message: 'No puedes crear el documento sin fecha de entrega' });
            return;
        }
        if (userFields?.length == 0) {
            enableSpinner(true)
            const apiResponse = await apiClient.getUserFields();
            enableSpinner(false)
            this.setState({
                userFields: apiResponse?.data ?? []
            })
        }

        $('#commentsModal').modal('show');

        this.setState({
            comentario: 2,
        })
    }

    sendOrderDiscount = async (response = null) => {
        const { enableSpinner, sessionReducer: { role, user }, notificationReducer: { showAlert }, itemsReducer: { deleteShoppingCart }, configReducer: { history } } = this.props;
        const { address, bill, DocDueDate, userFields } = this.state;
        let shoppingCart = [];

        enableSpinner(true);

        if (role === ROLES.PUBLIC) {
            let localShoppingCart = localStorage.getItem(config.general.localStorageNamed + 'shoppingCart');

            localShoppingCart = JSON.parse(localShoppingCart);

            if (!localShoppingCart) {
                localStorage.setItem(config.general.localStorageNamed + 'shoppingCart', JSON.stringify([]));
            }
            //console.log(localShoppingCart)
            shoppingCart = localShoppingCart || []
        }
        //Creador del documento
        let creatorUser = JSON.parse(localStorage.getItem(config.general.localStorageNamed + 'PartnerUser'));
        let empID = JSON.parse(localStorage.getItem(config.general.localStorageNamed + 'Vendor'));
        let creator;
        if (Number(creatorUser.U_FMB_Handel_Perfil) === 1) {
            creator = "Telemarketing:" + (creatorUser.salesPrson || creatorUser.empID) + ", " + creatorUser.firstName + " " + creatorUser.lastName;
        } else if (Number(creatorUser.U_FMB_Handel_Perfil) === 2) {
            creator = "Vendedor:" + (creatorUser.salesPrson || creatorUser.empID) + ", " + creatorUser.firstName + " " + creatorUser.lastName;
        } else if (Number(creatorUser.U_FMB_Handel_Perfil) === 3) {
            creator = "Administrador:" + (creatorUser.salesPrson || creatorUser.empID) + ", " + creatorUser.firstName + " " + creatorUser.lastName;
        } else {
            creator = "B2B:" + user.CardName;
        }
        //Definicion del vendedor
        empID = empID.salesPerson;

        let data = {
            shoppingCart,
            address,
            bill,
            objType: '17',
            responseFlete,
            empID,
            creator,
            taxOnly: 1,
            venta: '02',
            comment: response,
            Version: 'VerF: ' + global.appVersion,
            DocDueDate,
            creatorUser,
            userFields
        };

        let apiResponse = await apiClient.createDocument(data);

        //console.log(apiResponse);

        if (apiResponse.status === SERVICE_RESPONSE.SUCCESS) {
            deleteShoppingCart({ item: {}, deleteAll: true });
            enableSpinner(false);
            localStorage.setItem(config.general.localStorageNamed + 'createOrder', apiResponse.data.docNum);
            history.goCreateOrder();
            return;
        }

        showAlert({ type: 'error', message: apiResponse.message });
        enableSpinner(false)

    };

    sendQuotation = async response => {
        const { enableSpinner, sessionReducer: { role }, notificationReducer: { showAlert }, itemsReducer: { deleteShoppingCart }, configReducer: { history } } = this.props;
        const { address, bill } = this.state;
        let shoppingCart = [];

        enableSpinner(true);
        let empID = JSON.parse(localStorage.getItem(config.general.localStorageNamed + 'Vendor'));
        //console.log("Empleado en Cotizacion",empID);
        empID = empID.salesPerson;
        //Creador del documento
        let creatorUser = JSON.parse(localStorage.getItem(config.general.localStorageNamed + 'PartnerUser'));
        let creator;
        if (creatorUser.U_FMB_Handel_Perfil === "1") {
            creator = "Telemarketing-SalesPrson:" + creatorUser.salesPrson + ", " + creatorUser.firstName + " " + creatorUser.lastName;
        } else {
            creator = "Vendedor-SalesPrson:" + creatorUser.salesPrson + ", " + creatorUser.firstName + " " + creatorUser.lastName;
        }

        if (role === ROLES.PUBLIC) {
            let localShoppingCart = localStorage.getItem(config.general.localStorageNamed + 'shoppingCart');

            localShoppingCart = JSON.parse(localShoppingCart);

            if (!localShoppingCart) {
                localStorage.setItem(config.general.localStorageNamed + 'shoppingCart', JSON.stringify([]));
            }
            //console.log(localShoppingCart)
            shoppingCart = localShoppingCart || []
        }

        let data = {
            shoppingCart,
            address,
            bill,
            objType: '23',
            responseFlete,
            empID,
            creator
        };

        //console.log("se va para crear",data);

        let apiResponse = await apiClient.createQuotation(data);

        //console.log(apiResponse);

        if (apiResponse.status === SERVICE_RESPONSE.SUCCESS) {
            deleteShoppingCart({ item: {}, deleteAll: true });
            enableSpinner(false);
            localStorage.setItem(config.general.localStorageNamed + 'createOrder', apiResponse.data.docNum);
            history.goCreateOrder();
            return;
        }

        showAlert({ type: 'error', message: apiResponse.message });
        enableSpinner(false)

    };

    sendPreliminar = async response => {
        const { enableSpinner, sessionReducer: { role }, notificationReducer: { showAlert }, itemsReducer: { deleteShoppingCart }, configReducer: { history } } = this.props;
        const { address, bill } = this.state;
        let shoppingCart = [];

        enableSpinner(true);
        let empID = JSON.parse(localStorage.getItem(config.general.localStorageNamed + 'Vendor'));
        //console.log("Empleado en Cotizacion",empID);
        empID = empID.salesPerson;
        //Creador del documento
        let creatorUser = JSON.parse(localStorage.getItem(config.general.localStorageNamed + 'PartnerUser'));
        let creator;
        if (creatorUser) {
            if (creatorUser.U_FMB_Handel_Perfil === "1") {
                creator = "Telemarketing-SalesPrson:" + creatorUser.salesPrson + ", " + creatorUser.firstName + " " + creatorUser.lastName;
            } else {
                creator = "Vendedor-SalesPrson:" + creatorUser.salesPrson + ", " + creatorUser.firstName + " " + creatorUser.lastName;
            }
        } else {
            creator = "Cleinte-Generate";
        }

        if (role === ROLES.PUBLIC) {
            let localShoppingCart = localStorage.getItem(config.general.localStorageNamed + 'shoppingCart');

            localShoppingCart = JSON.parse(localShoppingCart);

            if (!localShoppingCart) {
                localStorage.setItem(config.general.localStorageNamed + 'shoppingCart', JSON.stringify([]));
            }
            //console.log(localShoppingCart)
            shoppingCart = localShoppingCart || []
        }

        let data = {
            shoppingCart,
            address,
            bill,
            objType: '17',
            responseFlete,
            empID,
            creator
        };

        //console.log("se va para crear",data);

        let apiResponse = await apiClient.createPreliminar(data);

        //console.log(apiResponse);

        if (apiResponse.status === SERVICE_RESPONSE.SUCCESS) {
            deleteShoppingCart({ item: {}, deleteAll: true });
            enableSpinner(false);
            localStorage.setItem(config.general.localStorageNamed + 'createOrder', apiResponse.data.docNum);
            history.goCreateOrder();
            return;
        }

        showAlert({ type: 'error', message: apiResponse.message });
        enableSpinner(false)

    };

    sendDelivery = async response => {
        const { enableSpinner, sessionReducer: { role }, notificationReducer: { showAlert }, itemsReducer: { deleteShoppingCart }, configReducer: { history } } = this.props;
        const { address, bill } = this.state;
        let shoppingCart = [];

        enableSpinner(true);
        let empID = JSON.parse(localStorage.getItem(config.general.localStorageNamed + 'Vendor'));
        //console.log("Empleado en Cotizacion",empID);
        empID = empID.salesPerson;
        //Creador del documento
        let creatorUser = JSON.parse(localStorage.getItem(config.general.localStorageNamed + 'PartnerUser'));
        let creator;
        if (creatorUser.U_FMB_Handel_Perfil === "1") {
            creator = "Telemarketing-SalesPrson:" + creatorUser.salesPrson + ", " + creatorUser.firstName + " " + creatorUser.lastName;
        } else {
            creator = "Vendedor-SalesPrson:" + creatorUser.salesPrson + ", " + creatorUser.firstName + " " + creatorUser.lastName;
        }

        if (role === ROLES.PUBLIC) {
            let localShoppingCart = localStorage.getItem(config.general.localStorageNamed + 'shoppingCart');

            localShoppingCart = JSON.parse(localShoppingCart);

            if (!localShoppingCart) {
                localStorage.setItem(config.general.localStorageNamed + 'shoppingCart', JSON.stringify([]));
            }
            //console.log(localShoppingCart)
            shoppingCart = localShoppingCart || []
        }

        let data = {
            shoppingCart,
            address,
            bill,
            objType: '15',
            responseFlete,
            empID,
            creator
        };

        //console.log("se va para crear",data);

        let apiResponse = await apiClient.createDelivery(data);

        //console.log(apiResponse);

        if (apiResponse.status === SERVICE_RESPONSE.SUCCESS) {
            deleteShoppingCart({ item: {}, deleteAll: true });
            enableSpinner(false);
            localStorage.setItem(config.general.localStorageNamed + 'createOrder', apiResponse.data.docNum);
            history.goCreateOrder();
            return;
        }

        showAlert({ type: 'error', message: apiResponse.message });
        enableSpinner(false)

    };

    sendSavedCart = async response => {
        const { enableSpinner, sessionReducer: { role, user }, notificationReducer: { showAlert }, shoppingCartReducer: { itemsGift, items }, itemsReducer: { deleteShoppingCart }, configReducer: { history } } = this.props;
        const { address, bill } = this.state;
        let shoppingCart = [];
        if (itemsGift.length > 0) {
            showAlert({ type: 'warning', message: 'Los artículos de bonificacion no se guardan' });
        }
        enableSpinner(true);
        //Creador del documento
        let creatorUser = JSON.parse(localStorage.getItem(config.general.localStorageNamed + 'PartnerUser'));
        let empID = JSON.parse(localStorage.getItem(config.general.localStorageNamed + 'Vendor'));
        let creator;
        if (Number(creatorUser.U_FMB_Handel_Perfil) === 1) {
            creator = "Telemarketing:" + (creatorUser.salesPrson || creatorUser.empID) + ", " + creatorUser.firstName + " " + creatorUser.lastName;
        } else if (Number(creatorUser.U_FMB_Handel_Perfil) === 2) {
            creator = "Vendedor:" + (creatorUser.salesPrson || creatorUser.empID) + ", " + creatorUser.firstName + " " + creatorUser.lastName;
        } else if (Number(creatorUser.U_FMB_Handel_Perfil) === 3) {
            creator = "Administrador:" + (creatorUser.salesPrson || creatorUser.empID) + ", " + creatorUser.firstName + " " + creatorUser.lastName;
        } else {
            creator = "B2B:" + user.CardName;
        }
        //Definicion del vendedor
        empID = empID.salesPerson;

        if (role === ROLES.PUBLIC) {
            let localShoppingCart = localStorage.getItem(config.general.localStorageNamed + 'shoppingCart');
            localShoppingCart = JSON.parse(localShoppingCart);

            if (!localShoppingCart) {
                localStorage.setItem(config.general.localStorageNamed + 'shoppingCart', JSON.stringify([]));
            }
            //console.log(localShoppingCart)
            shoppingCart = localShoppingCart || []
        }
        let totalbruto = 0;
        let totalneto = 0;
        let unidades = 0;
        let articulos = items.length;
        items.map(item => {
            let bruto = Number(item.weight1 * item.quantity);
            totalbruto += bruto;
            let neto = Number(item.weight * item.quantity);
            totalneto += neto;
            let cantidadArti = Number(item.quantity);
            unidades += cantidadArti
        });

        let data = {
            shoppingCart,
            address,
            bill,
            objType: '15',
            responseFlete,
            empID,
            creator,
            Valor: this.totalOrder().total,
            totalneto: parseFloat(totalneto).toFixed(2),
            totalbruto: parseFloat(totalbruto).toFixed(2),
            articulos,
            unidades,
            creatorUser,
        };

        //console.log("se va para crear",data);
        let apiResponse = await apiClient.createSavedCart(data);

        //console.log(apiResponse);

        if (apiResponse.status === SERVICE_RESPONSE.SUCCESS) {
            deleteShoppingCart({ item: {}, deleteAll: true });
            enableSpinner(false);
            localStorage.setItem(config.general.localStorageNamed + 'createOrder', apiResponse.data.docNum);
            history.goCreateOrder();
            return;
        }

        showAlert({ type: 'error', message: apiResponse.message });
        enableSpinner(false)

    };

    renderPaymentMethod = (total = null, currency = null) => {
        const { paymentMethod, totalOrder } = this.state;
        const { enableSpinner } = this.props;
        if (paymentMethod === 'paypal') {
            paypalOptions.currency = currency;
            if (total && currency) return <div>
                <PayPalButton
                    paypalOptions={paypalOptions}
                    buttonStyles={buttonStyles}
                    onPaymentStart={() => {
                        //console.log("start payment paypal");
                        enableSpinner(true)
                    }}
                    onPaymentCancel={() => {
                        //console.log("cancel payment paypal");
                        enableSpinner(false)
                    }}
                    onPaymentError={(msg) => {
                        //console.log("error payment paypal", msg);
                        enableSpinner(false)
                    }}
                    onPaymentSuccess={this.sendOrder}
                    amount={total}
                />
            </div>
        }
    };

    download = () => {
        const { enableSpinner, sessionReducer: { user }, notificationReducer: { showAlert }, shoppingCartReducer: { itemsGift, items } } = this.props;

        if (itemsGift.length > 0) {
            showAlert({ type: 'warning', message: 'Los artículos de bonificacion no se guardan' });
        }
        enableSpinner(true);

        // 'UNIDADES SOLICITADAS': ,
        // 'MASTER PACK (unidades)':'',
        // 'CODIGO EAN': '',
        // 'PTV-RINTI':,

        let csvData = [];

        if (items.length > 0) {
            items.map((item) => {
                let row = {
                    '': '',
                    'DESCRIPCIÓN': item.ItemName,
                    'CÓDIGO': item.ItemCode,
                    'CANTIDAD': item.quantity,
                    'PRECIO UNITARIO': parseFloat(item.priceTax).toFixed(2), // parseFloat(item.Price).toFixed(2),
                    'DESCUENTO': item.Discount === null ? '0 %' : parseFloat(item.Discount).toFixed(2) + ' %',
                    'PRECIO TOTAL': parseFloat(item.priceTax * item.quantity).toFixed(2), // parseFloat(item.Price * item.quantity - (item.Price * item.quantity * (item.Discount / 100))).toFixed(2),
                    'PESO NETO': parseFloat(item.quantity * item.weight).toFixed(2),
                    'PESO NETO EN': 'KG',
                    'PESO BRUTO': parseFloat(item.quantity * item.weight1).toFixed(2),
                    'PESO BRUTO EN': 'KG',
                    'CLIENTE': '',
                    'NOMBRE': '',
                }
                csvData.push(row);
            });
            csvData[0].CLIENTE = user.CardCode;
            csvData[0].NOMBRE = user.CardName;

            this.setState({
                csvData,
                action: 1
            });
        }
        enableSpinner(false)

    };

    totalOrder = () => {
        const { shoppingCartReducer: { items } } = this.props;

        let subTotal = 0;
        let taxTotal = 0;
        let total = 0;
        let tax = 0;
        let localLanguage = '';
        let currency = '';
        //Variables para validacion del Flete
        let transport = 0;
        let taxTransport = 0;
        let limit = 0;
        items.map(item => {
            //let totalPrice = Number(item.Price * item.quantity);
            let totalPrice = Number(item.Price * item.quantity - (item.Price * item.quantity * (item.Discount / 100)));
            subTotal += totalPrice;
            tax = item.taxRate;
            taxTotal += Number(item.taxSum * item.quantity);
            localLanguage = item.localLanguage;
            currency = item.currency;
        });

        let IGV = tax * subTotal / 100;
        //Asignacion de valores para el flete
        limit = parseInt(responseFlete.PurchaseLimit);
        transport = parseFloat(responseFlete.Price);
        taxTransport = parseFloat(transport * (tax * 0.01));
        //Validacion del flete
        if (subTotal < limit) {
            taxTotal = taxTotal + taxTransport;
            total = subTotal + transport + taxTotal;
        } else {
            transport = 0;
            total = subTotal + transport + taxTotal;
        }

        total = subTotal + IGV;

        //total = subTotal + taxTotal;
        return { total: total.toFixed(2), currency: currency === 'MXP' ? 'MXN' : currency };
    };

    inputDocDueDate = event => {
        let DocDueDate = event.nativeEvent.target.value;
        this.setState({
            DocDueDate
        });
    }
    updateFields = userFields => {
        this.setState({
            userFields
        })
    }

    render() {
        const { history, sessionReducer: { user }, shoppingCartReducer: { items, itemsGift } } = this.props;
        const { seller, comentario, csvData, fechaActual, DocDueDate, userFields } = this.state;

        let currency = this.totalOrder().currency;
        let total = this.totalOrder().total;
        return (
            <div className="content-fluid" style={{ marginTop: 69 }}>
                <Session history={history} view={VIEW_NAME.VALIDATE_ORDER_VIEW} />
                <NavBar />
                <CommentsModal
                    sendOrder={this.sendOrder}
                    sendOrderVta={this.sendOrderDiscount}
                    tipo={comentario}
                    userFields={userFields}
                    updateFields={this.updateFields}
                />

                <div className="row" style={{ marginTop: 100, marginLeft: 40, marginRight: 40, minHeight: '70vh' }}>
                    <div className="col-sm-9">
                        <div className="card style-articles-cart" style={{ borderColor: 'white', border: '1px solid  rgba(124, 124, 125, 0.3)' }}>
                            <div className="card-header" style={{ background: config.shoppingList.productList }}>
                                <h4 className="card-title" style={{ color: config.shoppingList.textProductList }}>
                                    Últimos detalles <spam className="small">(precios con I.G.V.):</spam>
                                </h4>
                            </div>
                            <div className="card-body">
                                {items.map((item, index) => {
                                    return this.renderItem(item, index);
                                })}
                            </div>
                            <div className="card-body">

                                {itemsGift.map((items) => { return this.renderItemPromo(items) })}
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-3">
                        <div className="card" style={{ borderColor: 'white', backgroundColor: 'transparent', border: '1px solid  rgba(124, 124, 125, 0.3)' }}>
                            <div className="card-header text-white" style={{ background: config.shoppingList.summaryList }}>
                                <div className="card-title">
                                    <h5 style={{ color: config.shoppingList.textsummaryList }}>Detalles del envío</h5>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-12">
                                        <span className="font-weight-bold" style={{ fontSize: 17 }}>Dirección de envío</span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        {this.renderAddress()}
                                    </div>
                                </div>
                                <div className="row bg-light">
                                    <div className="col-md-auto">
                                        <span className="font-weight-bold" style={{ fontSize: 17 }}>Total a pagar</span>
                                    </div>
                                    <div className="col-md-auto text-right">
                                        <span style={{ fontSize: 18, color: config.itemsList.textPrice }}>
                                            {/* <CurrencyFormat 
                                                value={total} 
                                                displayType={'text'} 
                                                thousandSeparator={'.'}
                                                decimalSeparator={','}
                                                prefix={config.general.currency}>
                                            </CurrencyFormat> */}
                                            <CurrencyFormat
                                                value={total}
                                                displayType={'text'}
                                                thousandSeparator={true}
                                                fixedDecimalScale={true}
                                                decimalScale={2}
                                                prefix={config.general.currency}>
                                            </CurrencyFormat>
                                        </span>
                                    </div>
                                </div>
                                <div className="row bg-light" style={{ paddingBottom: '5px' }}>
                                    <div className="col-md-auto text-left">
                                        <span className="font-weight-bold" style={{ fontSize: 17 }}>Fecha de entrega</span>
                                    </div>
                                    <div className="col-md-auto text-right">
                                        <input
                                            id="DocDueDate"
                                            type="date"
                                            className="form-control"
                                            name="fechauno"
                                            min={fechaActual}
                                            value={DocDueDate}
                                            onChange={(event) => this.inputDocDueDate(event)} />
                                    </div>
                                </div>
                                {/* <div className="row">
                                    <div className="col-12">
                                        <span className="font-weight-bold" style={{fontSize: 17}}>Método de pago</span>
                                    </div>
                                </div> */}
                                {user ? user.U_RNT_AUTG === 'N' || seller.U_FMB_Handel_Perfil !== '0' ?
                                    <button
                                        onClick={this.enviar}
                                        className="btn btn-block"
                                        style={{
                                            backgroundColor: config.navBar.menuCategoriesBackgroundHover,
                                            color: config.navBar.textColorCategorieHover,
                                            fontWeight: "bold",
                                        }}>
                                        Crear orden de venta
                                    </button>
                                    : "" : ""
                                }

                                {seller ? seller.U_FMB_Handel_Perfil === 1 ? //seller.U_FMB_Handel_Perfil != 0 ?

                                    <button
                                        onClick={this.enviarVta}
                                        className="btn btn-block"
                                        style={{
                                            backgroundColor: config.navBar.menuCategoriesBackgroundHover,
                                            color: config.navBar.textColorCategorieHover,
                                            fontWeight: "bold",
                                        }}>
                                        Transferencia gratuita
                                    </button>
                                    : "" : ""
                                }

                                {/* <button
                                    onClick={this.sendDelivery}
                                    className="btn btn-block"
                                    style={{
                                        backgroundColor: config.navBar.menuCategoriesBackgroundHover,
                                        color: config.navBar.textColorCategorieHover,
                                        fontWeight: "bold",
                                    }}>
                                    Crear entrega
                                </button>
                                <button
                                    onClick={this.sendQuotation}
                                    className="btn btn-block"
                                    style={{
                                        backgroundColor: config.navBar.menuCategoriesBackgroundHover,
                                        color: config.navBar.textColorCategorieHover,
                                        fontWeight: "bold",
                                    }}>
                                    Crear cotizacion
                                </button>
                                <button
                                    onClick={this.sendPreliminar}
                                    className="btn btn-block"
                                    style={{
                                        backgroundColor: config.navBar.menuCategoriesBackgroundHover,
                                        color: config.navBar.textColorCategorieHover,
                                        fontWeight: "bold",
                                    }}>
                                    Crear pedido preliminar
                                </button> */}
                                <button
                                    onClick={this.sendSavedCart}
                                    className="btn btn-block"
                                    style={{
                                        backgroundColor: config.navBar.menuCategoriesBackgroundHover,
                                        color: config.navBar.textColorCategorieHover,
                                        fontWeight: "bold",
                                    }}>
                                    Guardar carrito para después
                                </button>

                                {/* <button
                                    onClick={this.download}
                                    className="btn btn-block btn-success"
                                    style={{
                                        // backgroundColor: config.navBar.menuCategoriesBackgroundHover,
                                        color: config.navBar.textColorCategorieHover,
                                        fontWeight: "bold",
                                    }}>
                                    Descargar Excel <i class="fa fa-file-excel-o" aria-hidden="true"></i>
                                </button> */}

                                <CSVLink
                                    className="btn btn-block btn-success"
                                    onClick={this.download}
                                    style={{
                                        color: config.navBar.textColorCategorieHover,
                                        fontWeight: "bold",
                                    }}
                                    data={csvData} filename={"OrdenDeVenta.csv"}>
                                    Descargar Excel <i class="fa fa-file-excel-o" aria-hidden="true"></i>
                                </CSVLink>
                                <button
                                    className="btn btn-block btn-light"
                                    style={{
                                        color: config.navBar.textColorCategorieHover,
                                    }}>
                                    <ExportReportPDFOrder data={items} user={user}></ExportReportPDFOrder>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = store => {
    return {
        itemsReducer: store.ItemsReducer,
        sessionReducer: store.SessionReducer,
        configReducer: store.ConfigReducer,
        notificationReducer: store.NotificationReducer,
        shoppingCartReducer: store.ShoppingCartReducer
    };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value }),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ValidateOrderView);